export const TRUSTED_COMPANIES = [
  { name: "Google", logo: "https://upload.wikimedia.org/wikipedia/commons/2/2f/Google_2015_logo.svg" },
  { name: "Microsoft", logo: "https://upload.wikimedia.org/wikipedia/commons/9/96/Microsoft_logo_%282012%29.svg" },
  { name: "Amazon", logo: "https://upload.wikimedia.org/wikipedia/commons/a/a9/Amazon_logo.svg" },
  { name: "Meta", logo: "https://upload.wikimedia.org/wikipedia/commons/7/7b/Meta_Platforms_Inc._logo.svg" },
  { name: "Adobe", logo: "https://upload.wikimedia.org/wikipedia/commons/7/7b/Adobe_Systems_logo_and_wordmark.svg" },
  { name: "IBM", logo: "https://upload.wikimedia.org/wikipedia/commons/5/51/IBM_logo.svg" },
  { name: "Oracle", logo: "https://upload.wikimedia.org/wikipedia/commons/5/50/Oracle_logo.svg" },
  { name: "Salesforce", logo: "https://upload.wikimedia.org/wikipedia/commons/f/f9/Salesforce.com_logo.svg" },
  { name: "Intel", logo: "https://upload.wikimedia.org/wikipedia/commons/7/7d/Intel_logo_%282006-2020%29.svg" },
  { name: "Cisco", logo: "https://upload.wikimedia.org/wikipedia/commons/0/08/Cisco_logo_blue_2016.svg" },
  { name: "SAP", logo: "https://upload.wikimedia.org/wikipedia/commons/5/59/SAP_2011_logo.svg" },
  { name: "Accenture", logo: "https://upload.wikimedia.org/wikipedia/commons/c/cd/Accenture.svg" },
  { name: "Deloitte", logo: "https://upload.wikimedia.org/wikipedia/commons/e/ed/Logo_of_Deloitte.svg" },
  { name: "Goldman Sachs", logo: "https://upload.wikimedia.org/wikipedia/commons/6/61/Goldman_Sachs.svg" },
  { name: "JPMorgan", logo: "https://upload.wikimedia.org/wikipedia/commons/2/20/JPMorgan_logo.svg" },
  { name: "Walmart", logo: "https://upload.wikimedia.org/wikipedia/commons/5/5b/Walmart_logo_%282025%29.svg" },
  { name: "Visa", logo: "https://upload.wikimedia.org/wikipedia/commons/5/5c/Visa_Inc._logo_%282021%E2%80%93present%29.svg" },
  { name: "Mastercard", logo: "https://upload.wikimedia.org/wikipedia/commons/2/2a/Mastercard-logo.svg" },
];

export const HERO_SECTION = {
  badge: "India's AI-powered Learning + Hiring Ecosystem",
  headline: "India's first AI-powered B.Tech Ecosystem.",
  subheadline: "A 4-year B.Tech ecosystem that turns theoretical learning into verifiable tech mastery and predictable placements.",
  ctaPrimary: "Join the Waitlist",
  ctaSecondary: "Partner With Us",
  meta: "2,847+ students & 60+ companies already on the waitlist",
};

export const STATS_QUOTE_SECTION = {
  tag: "The Numbers That Drive Us",
  headline: "We're not building another EdTech. We're building infrastructure.",
  defaultStats: { students_waitlist: 2847, hiring_partners: 60, university_partners: 18 },
  quote: {
    text: "Every student deserves not just an education but a clear, unstoppable path to success. That is not a mission statement. It is the reason aiprof was built.",
    author: "Sandeep Konam",
    role: "Founder, AI Prof",
    img: `${process.env.PUBLIC_URL}/general/sandeep_quote_img.png`,
  },
};

export const COMPARISON_SECTION = {
  tag: "Why AI Prof Exists",
  headline: "You don't need another course. You need a system that connects learning to your dream jobs.",
  columnLabels: {
    dimension: "Dimension",
    traditional: "Traditional College",
    generic: "Generic Course Platform",
    aiprof: "AI.Prof Solution",
  },
  bottomQuote: {
    label: "A Choice",
    heading: "Don't leave your career to luck.",
    subheading1: "Eliminate the gamble.",
    subheading2: "Engineer the outcome.",
    description: "Build undeniable, verified proof from Semester 1.",
  },
};

export const SKILL_GAP_SECTION = {
  badge: "The Skill Gap",
  headline1: "India produces 1.5M engineers every year.",
  headline2: "Less than 20% are industry-ready.",
  description: "This is not a student problem. It's a system problem. AI Prof was built to solve this.",
  whatCompaniesWant: [
    "Hands-on coding & deployment experience",
    "Real GitHub repositories & project history",
    "AI/ML awareness with practical exposure",
    "Problem-solving under real constraints",
    "Communication & collaboration skills",
  ],
  whatCollegesDeliver: [
    "Theory-heavy curriculum, limited lab time",
    "Assignments graded for marks, not mastery",
    "Subjects 3–5 years behind industry trends",
    "Placement support only in final year",
    "No verified proof of student skills",
  ],
  stats: [
    { value: "1.5M+", label: "Engineering grads every year in India", color: "text-blue-600", iconColor: "text-blue-600", iconBg: "bg-blue-50" },
    { value: "<20%", label: "Industry-ready on Day 1", color: "text-orange-500", iconColor: "text-orange-500", iconBg: "bg-orange-50" },
    { value: "3–12", label: "Months to catch up after college", color: "text-blue-600", iconColor: "text-blue-600", iconBg: "bg-blue-50" },
    { value: "44%", label: "Professionals need new AI skills by 2030 — McKinsey", color: "text-orange-500", iconColor: "text-orange-500", iconBg: "bg-orange-50" },
  ],
  solution: {
    badge: "The AI Prof Solution",
    text: "AI Prof bridges this gap not just with better content, but with a full ecosystem: AI-powered learning, real project portfolios, skill-tracking dashboards for universities, and an AI hiring pipeline that connects students directly to companies.",
    tags: ["AI-Powered Learning", "Real Project Portfolios", "Skill Dashboards", "Hiring Pipeline"],
  },
};

export const PROGRAMMES_SECTION = {
  tag: "Programmes",
  headline: "Learn what the industry actually hires for.",
  filters: ["All", "Full Stack", "AI/ML", "Data Science", "Cloud", "Cybersecurity"],
  flagship: {
    tag: "Flagship Programme",
    title: "Computer Science + AI — 4-Year Programme",
    description: "A full undergraduate degree in Computer Science, redesigned with AI-integrated curriculum, real-world projects, Veda AI tutoring, and placement support from Semester 1.",
    features: [
      "🎓 4-year integrated degree",
      "🌐 Partnered universities",
      "💼 Placement support included",
    ],
    cta: "Learn More",
  },
  coursesSection: {
    tag: "Courses",
    headline: "Specialized tracks. Industry-ready faster.",
    cta: "Join Waitlist",
  },
};

export const MENTORS_SECTION = {
  tag: "Learn From The Best",
  headline: "Engineers at the world's best companies.",
  description: "Get direct guidance, industry tips, and expert mentorship from top global tech engineers.",
  cardFooter: "Live Q&A · Office Hours · Portfolio Reviews",
};

export const FAQ_SECTION = {
  tag: "Got Questions?",
  headline: "We've got answers.",
};